module.exports = __webpack_public_path__ + "img/l_cq.cd5a9f6c.png";